import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OrganizerHeader } from "../../components/header";
import { AleartModalButton, PrimaryButton, TextInput } from "../../components/UIkit";
import { push } from "connected-react-router";
import { getCurrentUser, getUserId } from "../../reducks/users/selectors";
import { fechCurrentUser, updataEmail } from "../../reducks/users/operations";

const MailEdit = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const uid = getUserId(selector);
  const currentUser = getCurrentUser(selector);
  const isBoothEditing = true;
  const isOpusEditing = true;

  const [email, setEmail] = useState("");
  const [newMail, setNewMail] = useState("");
  const [password, setPassword] = useState("");

  const inputEmail = useCallback(
    (event) => {
      setEmail(event.target.value);
    },
    [setEmail]
  );
  const inputNewMail = useCallback(
    (event) => {
      setNewMail(event.target.value);
    },
    [setNewMail]
  );
  const inputPassword = useCallback(
    (event) => {
      setPassword(event.target.value);
    },
    [setPassword]
  );

  const validateEmailFormat = (email) => {
    // const regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return regex.test(email);
  };
  const validateRequiredInput = (...args) => {
    let isBlank = false;
    for (let i = 0; i < args.length; i = (i + 1) | 0) {
      if (args[i] === "") {
        isBlank = true;
      }
    }
    return isBlank;
  };

  const submitEmailEdit = () => {
    const isBlank = validateRequiredInput(email);
    const isValidEmail = validateEmailFormat(email);
    if (isBlank) {
      alert("必須入力欄が空白です");
      return false;
    } else if (!isValidEmail) {
      alert("メールアドレスの書式が異なります");
      return false;
    } else {
      dispatch(updataEmail(newMail, email, password, uid));
    }
  };

  const fechEmail = () => {
    setEmail(currentUser.email);
  };

  useEffect(() => {
    dispatch(fechCurrentUser(uid));

    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    fechEmail();
    // eslint-disable-next-line
  }, [currentUser]);

  return (
    <section>
      <div className="common-container">
        <div className="common-container__header--inner center-box">
          <OrganizerHeader isBoothEditing={isBoothEditing} isOpusEditing={isOpusEditing} />
          <div className="mypage-container">
            <h2 className="form-text__headline--l center">メールアドレスの変更</h2>
            <div className="spacer-box--s" />
            <div className="center">
              <div className="input-wide--basic center-box">
                <TextInput
                  fullWidth={true}
                  label={"新しいメールアドレス"}
                  multiline={false}
                  required={true}
                  rows={1}
                  value={newMail ?? ""}
                  type={"email"}
                  onChange={inputNewMail}
                />
                <div className="spacer-box--s" />

                <TextInput
                  fullWidth={true}
                  label={"現在のメールアドレス"}
                  multiline={false}
                  required={true}
                  rows={1}
                  value={email ?? ""}
                  type={"email"}
                  onChange={inputEmail}
                />
                <div className="spacer-box--s" />

                <TextInput
                  fullWidth={true}
                  label={"パスワード"}
                  multiline={false}
                  required={true}
                  rows={1}
                  value={password ?? ""}
                  type={"password"}
                  onChange={inputPassword}
                />
              </div>
              <div className="spacer-box--m" />
              <PrimaryButton label={"変更する"} onClick={() => submitEmailEdit()} />
              <div className="spacer-box--m" />
              <AleartModalButton
                title="保存されいない内容は消去されます"
                text="よろしいですか？"
                onClick={() => dispatch(push("/Account"))}
                label="アカウントページに戻る"
                className="top-back-btn"
              />
              <div className="spacer-box--l" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MailEdit;
